import AbstractFormulaTokenVisitor from "../../../../models/keyFigure/formulaToken/visitors/AbstractFormulaTokenVisitor.js";

/**
 * Visit a formula token and build a CSS class for the modal form.
 */
export default class FormulaTokenFormCSSClassBuilder extends AbstractFormulaTokenVisitor {
	visitAbstractFormulaToken() {
		return "modal-overflow";
	}

	visitKeyFigureFormulaToken() {
		return "modal-keyfigure";
	}
}
